import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSetUser } from "../contexts/UserContext";

const LogoutButton = () => {
  const navigate = useNavigate();
  const setUser = useSetUser();
  const handleLogout = async () => {
    try {
      await axios.post("/api/auth/logout", {}, { withCredentials: true });
    } catch {
      // Still sign out locally if the API is unreachable.
    }
    setUser(null);
    localStorage.removeItem("accessToken");
    navigate("/login");
  };
  return (
    <Tooltip title="Logout">
      <IconButton
        data-onboarding-logout
        color="inherit"
        onClick={handleLogout}
        aria-label="Log out"
      >
        <LogoutIcon />
      </IconButton>
    </Tooltip>
  );
};

export default LogoutButton;
